import axios, { type AxiosError } from 'axios';

export function isAxiosError<T = any, D = any>(
  error: unknown,
): error is AxiosError<T, D> {
  return axios.isAxiosError(error);
}
